import React from "react";

export const bestHistoricalSavingsPercent = (values) => {
  const percentages = values.filter((value) => value !== null && value !== undefined && value !== "")
    .map(Number).filter(Number.isFinite);
  return percentages.length ? Math.max(...percentages) : null;
};

export const savingsTextColor = (percent) => percent > 0
  ? "text-green-700" : percent < 0 ? "text-red-700" : "text-slate-600";

export default function HistoricalSavingsBadge({ percent }) {
  if (percent == null || !Number.isFinite(Number(percent))) return null;
  const value = Number(percent);
  const tone = value > 0
    ? "bg-green-100 text-green-800"
    : value < 0 ? "bg-red-100 text-red-800" : "bg-slate-100 text-slate-700";
  return <span className={`inline-flex w-fit rounded-full px-2 py-0.5 text-xs font-bold ${tone}`}
    title="Best available listing compared with its typical price">
    {Math.round(value)}%
  </span>;
}
